var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pageJoin"
  }, [_c('div', {
    staticClass: "pageJoin-main"
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "intro-img wow fadeInDown",
    style: {
      backgroundImage: `url(${require(`@images/${_vm.theme}/join-icon-frens.png`)})`
    },
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }), _c('div', {
    staticClass: "intro__title wow fadeInRight",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_vm._v(_vm._s(_vm.$lang("Join Squad")))]), _c('div', {
    staticClass: "intro__subtitle wow fadeInLeft",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang("Yes! Join a squad to swlpe and eari together.")) + " "), _c('p', [_vm._v(_vm._s(_vm.$lang("Maximize profits and climb the rinkings!")))])])]), _c('div', {
    staticClass: "btn-join",
    style: {
      background: _vm.themeMainColor(_vm.theme).main
    },
    on: {
      "click": _vm.onJoin
    }
  }, [_vm._v(_vm._s(_vm.$lang("Creat or Join a custom squad")))]), _vm.squadList.length > 0 ? _c('div', {
    staticClass: "recommend"
  }, [_c('div', {
    staticClass: "recommend__title"
  }, [_vm._v(_vm._s(_vm.$lang("Recommend Squad")))]), _vm.squadList && _vm.squadList.length > 0 ? [_c('transition-group', {
    staticClass: "recommend-list",
    attrs: {
      "tag": "div",
      "appear": ""
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterLongList
    }
  }, _vm._l(_vm.squadList, function (item, index) {
    return _c('div', {
      key: `l${index}`,
      staticClass: "recommend-item",
      attrs: {
        "data-index": index
      },
      on: {
        "click": function ($event) {
          return _vm.onRecommend(item);
        }
      }
    }, [_c('m-head', {
      attrs: {
        "src": item.group_icon,
        "size": 26
      }
    }), _c('div', {
      staticClass: "item-info"
    }, [_c('div', {
      staticClass: "item__label"
    }, [_vm._v(_vm._s(item.group_name))]), _c('div', {
      staticClass: "item__num"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.theme}/new/index-icon-small-coin.png`),
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(_vm._f("toPre")(item.group_coin, 3, true)) + " ")]), _c('div', {
      staticClass: "op"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-arrow"
      }
    })], 1)])], 1);
  }), 0)] : _vm._e()], 2) : _vm._e()]), _c('pop-join', {
    attrs: {
      "show": _vm.popJoinShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popJoinShow = $event;
      }
    }
  }), _c('pop-squad', {
    attrs: {
      "show": _vm.popSquadShow,
      "id": _vm.selectSquadId
    },
    on: {
      "update:show": function ($event) {
        _vm.popSquadShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };